import { Currency } from '../enums'

export class SboCurrency {
    constructor(data: Partial<SboCurrency> = {}) {
        Object.assign(this, data)
    }

    displayName: string = ''
    code: Currency = Currency.UNKNOWN

    toString(): string {
        return Currency[this.code]
    }

    isKAmount(): boolean {
        return this.code === Currency.MMK || this.code === Currency.IDR
    }

    IsKAmountAndVnd(): boolean {
        return this.code === Currency.MMK || this.code === Currency.IDR || this.code === Currency.VND
    }
}

export const depositNeedOtpCurrency: Currency[] = [Currency.KRW, Currency.INR]
